import Typography from '@mui/material/Typography'
import React, {memo} from 'react'
import PropTypes from 'prop-types'

export function Body(props) {
    const {
        text,
        bold,
        italic,
        children,
        clazz,
    } = props

    return (
        <Typography style={{wordWrap: 'break-word'}} className={clazz} variant='body1'>
            {bold && !italic &&
                <strong>
                    {text ?? ''}
                </strong>
            }

            {!bold && italic &&
                <em>
                    {text ?? ''}
                </em>
            }

            {bold && italic &&
                <strong>
                    <em>
                        {text ?? ''}
                    </em>
                </strong>
            }

            {!bold && !italic &&
                text
            }

            {children &&
                {children}
            }
        </Typography>
    )
}

export default memo(Body)

Body.propTypes = {
    text: PropTypes.string.isRequired,
    bold: PropTypes.bool,
    italic: PropTypes.bool,
    clazz: PropTypes.string,
}

